import { useEffect, useRef } from "react"

const MenuItem = (props) => {
  const itemRef = useRef(null)
  const tooltipRef = useRef(null)

  const positionTooltip = () => {
    if (!itemRef.current || !tooltipRef.current) return

    const item = itemRef.current.getBoundingClientRect()
    const tooltip = tooltipRef.current

    tooltip.style.left = `${item.right + 15}px`
    tooltip.style.top = `${item.top + item.height / 2}px`
    tooltip.style.transform = "translateY(-50%)"
  }

  useEffect(() => {
    const itemElement = itemRef.current
    if (!itemElement) return

    const handleMouseEnter = () => {
      positionTooltip()
    }

    itemElement.addEventListener("mouseenter", handleMouseEnter)

    // Clean up
    return () => {
      itemElement.removeEventListener("mouseenter", handleMouseEnter)
    }
  }, [])

  return (
    <li ref={itemRef}>
      <a className={props.active ? "active" : ""} href={props.link}>
        <i className={props.active ? props.icon + " blue" : props.icon}></i>
        <span className="links_name">{props.menuTitle}</span>
      </a>
      <span ref={tooltipRef} className="tooltip">
        {props.menuTitle}
      </span>
    </li>
  )
}
export default MenuItem